import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <AboutSection />
        <AppSection />
        <UpdatesSection />
        <RankingSection />
        <CommentsSection />
        <FaqSection />
        <CarouselSection />
        <FeaturesSection />
        <CardsSection />
        <MediaSection />
        <TopicsSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}